import { urlManger } from "@/url/common";
import { EntityUrl } from "@intasect/platform-core";
export const url_whitelist: EntityUrl = {
    get page() {
        return `${urlManger.getServiceUrl("user")}/cmb/org-white-list/findListPage`;
    }
};
